var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmobi4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 90,
    viewBox: "0 0 86 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6208 0V89.6811H0L12.4268 44.8405L0 0H85.6208Z",
    fill: "url(#paint0_linear_126_217)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7244 52.6254C66.7244 44.7767 61.7033 38.0796 54.705 35.5748C56.9925 33.7708 58.4634 30.9755 58.4634 27.843C58.4636 22.4156 54.0481 18 48.6207 18C43.1933 18 38.7778 22.4156 38.7778 27.8429C38.7778 30.9754 40.2489 33.7707 42.5363 35.5747C35.538 38.0796 30.517 44.7766 30.517 52.6254C30.517 55.7924 32.0208 58.6143 34.3515 60.4159C34.6005 52.7601 40.9052 46.6084 48.6207 46.6084C56.3361 46.6084 62.6409 52.7601 62.89 60.4159C65.2206 58.6142 66.7244 55.7923 66.7244 52.6254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6207 49.7725C42.4926 49.7725 37.507 54.7581 37.507 60.8862C37.507 67.0144 42.4926 72 48.6207 72C54.7489 72 59.7345 67.0144 59.7345 60.8862C59.7345 54.7581 54.7489 49.7725 48.6207 49.7725ZM47.702 64.5642C47.6925 64.5643 47.683 64.5645 47.6736 64.5645C47.2544 64.5645 46.8519 64.398 46.555 64.101L44.5468 62.0927C43.929 61.4749 43.929 60.4732 44.5468 59.8554C45.1646 59.2376 46.1664 59.2376 46.7841 59.8554L47.6329 60.7042L50.418 57.712C51.0135 57.0725 52.0146 57.0368 52.6539 57.632C53.2934 58.2273 53.3293 59.2284 52.734 59.8679L48.8317 64.0603C48.5392 64.3746 48.1312 64.5565 47.702 64.5642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_217",
    x1: 68.241,
    y1: 0,
    x2: 68.241,
    y2: 89.6811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(21.6207 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmobi4);
export default __webpack_public_path__ + "static/media/iconmobi4.7365736825ee25b7437c724da376252e.svg";
export { ForwardRef as ReactComponent };